import { API_ROOT } from 'environment';

// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
let module = angular.module('app.resources', []);

// The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.
require('./account');
require('./account_apple_tv_app');
require('./account_roku_app');
require('./account_channel');
require('./account_static_rtmp');
require('./account_storage_bill');
require('./account_subscriptions');
require('./activation_codes');
require('./boxcaster');
require('./broadcast');
require('./broadcast_upload');
require('./channel');
require('./channel_ticket');
require('./donation');
require('./inventory');
require('./manufacturer');
require('./order');
require('./origin');
require('./pandadoc');
require('./recording');
require('./reseller');
require('./scoreboard_assist');
require('./storage_bill');
require('./suppressed_email');
require('./ticket');
require('./upgrade');
require('./user');

export default module;



// WEBPACK FOOTER //
// ./resources/index.js